$(document).ready(function () {
  resizeImages();
  $(window).resize(function () {
    $(".homepage div[id^='swiper']").find(".swiper-container").css("height", $(window).height());
    $(".homepage div[id^='swiper']").find(".image-as-background").css("height", $(window).height());
  });
});

function resizeImages() {
  $(".homepage div[id^='swiper']").find(".swiper-container").css("height", $(window).height());
  $(".homepage div[id^='swiper']").find(".image-as-background").css("height", $(window).height());
};
window.initSwiper = function () {

  $('.swiper-container').each(function (index) {

    var $el = $(this);

    swiper[index] = $el.swiper({
      speed: 400,
      pagination: $el.find('.swiper-pagination')[0],
      paginationClickable: true,
      autoplay: $('body').hasClass('neos-backend') ? false : 10000,
      autoplayDisableOnInteraction: false,
      simulateTouch: false,
      loop: !$('body').hasClass('neos-backend')
    });

    $el.find('.prev-slide').on('click', function () {
      swiper[index].slidePrev();
    });

    $el.find('.next-slide').on('click', function () {
      swiper[index].slideNext();
    });

    positionSwipperBullets();

    $(window).resize(function () {

      updateSwipers();

      positionSwipperBullets();

    });

  });

}
